import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";

export default function EnterpriseCard() {
  return (
    <Card className="overflow-hidden border-0 bg-[#1f2937] text-white shadow-sm">
      <CardContent className="p-6">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2">
            <div className="inline-flex rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-white/70">
              Custom scale
            </div>
            <h3 className="text-lg font-semibold text-white">Enterprise</h3>
            <p className="text-white/70">
              Need higher limits, custom integrations, or dedicated support?
            </p>
          </div>
          <Button
            variant="secondary"
            className="bg-white text-stone-950 hover:bg-stone-100"
            onClick={() => window.open("https://t.me/plusefin", "_blank")}
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Contact Sales
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
